import { findMergeTokens, findMergeTokensInHtml, humanizeToken } from '@/lib/email/oneoff-merge';

// Builds the "unfilled blanks" pre-send warning. Tokens are unioned across the
// subject, the editor's plain text, AND the raw body HTML. The raw-HTML scan is
// what catches tokens hiding in attributes (e.g. a link `<a href="{{x}}">`) —
// findMergeTokens strips HTML via textContent, so attribute tokens are invisible
// to it.
export function buildUnfilledWarning(
  subjectText: string,
  bodyText: string,
  bodyHtml?: string,
): string | null {
  const tokens = Array.from(
    new Set([
      ...findMergeTokens(subjectText),
      ...findMergeTokens(bodyText),
      ...(bodyHtml ? findMergeTokensInHtml(bodyHtml) : []),
    ]),
  );
  if (tokens.length === 0) return null;
  const names = tokens.map(humanizeToken).join(', ');
  return `This email still has blanks that look unfinished: ${names}. Send anyway?`;
}

// Backstop for stale personalization: when the body was populated for one
// contact and the recipient was subsequently changed to someone else, the
// already-substituted name/company would ship to the wrong person and the
// unfilled-token gate cannot catch it (no `{{...}}` remain). Returns a confirm
// message in that case, else null.
export function buildRecipientMismatchWarning(
  populatedFromName: string | null,
  currentMatchesPopulatedContact: boolean,
): string | null {
  if (!populatedFromName || currentMatchesPopulatedContact) return null;
  return `This email was personalized for ${populatedFromName} but is now addressed to someone else. Send anyway?`;
}
